import React from 'react';

import { StyledFeatureTable } from './FeatureTable.styles';

import { FeatureTableProps } from './FeatureTable.types';

const FeatureTable = ({
  titleTable,
  optionList = [],
  featuresWithOptionsDetailsList = [],
  checkIcon,
  componentClassname = 'feature-table',
  customClassnames = '',
  customStyle = '',
  ...props
}: FeatureTableProps) => {
  return (
    <StyledFeatureTable
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      <table>
        <thead>
          <tr>
            <th className={`${componentClassname}__table-title`}>
              {titleTable}
            </th>
            {optionList?.map((option, index) => (
              <th
                className={`${componentClassname}__option`}
                key={`option-list-${index}`}
              >
                {option}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {featuresWithOptionsDetailsList?.map((feature, index) => (
            <tr key={index}>
              <td className={`${componentClassname}__feature`}>
                {feature.featureName}
              </td>
              {feature.optionsDetailsList?.map((optionDetails, index) => (
                <td
                  key={`option-details-${index}`}
                  className={`${componentClassname}__check`}
                >
                  {optionDetails.isChecked && (checkIcon || '✓')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </StyledFeatureTable>
  );
};
FeatureTable.displayName = 'FeatureTable';

export default FeatureTable;
